// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: DeleteModalMetadata
 ** @type: functional stateless component
 ** @description:
 **********/
const DeleteModalMetadata = props => {
	return (
		<Wrapper className="cell large-6">
			<h5 className="label">{props.label}</h5>
			<p className="value">{props.value}</p>
			{props.children}
		</Wrapper>
	);
};

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	flex: 1;
	margin-bottom: ${rem('16px')};

	.label,
	.value,
	small {
		text-align: left;
	}

	.label {
		color: ${props => props.theme.gray7};
		font-size: ${rem('12px')};
		text-transform: uppercase;
		letter-spacing: 1px;
		margin-bottom: ${rem('2px')};
	}

	.value {
		color: ${props => props.theme.gray9};
		font-size: ${rem('16px')};
		margin-bottom: 0;
    line-height: 1.1;
	}

	small {
    font-size: ${rem('12px')};
    margin-top: ${rem('4px')}
		color: ${props => props.theme.gray6};
	}
`;

DeleteModalMetadata.propTypes = {
	label: PropTypes.string,
	value: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default DeleteModalMetadata;



// WEBPACK FOOTER //
// ./src/components/general/modal/types/delete/delete-photo/delete-modal-metadata.jsx